module.exports = __webpack_public_path__ + "static/1357522236-exit.3f10c688.jpg";